module.exports = __webpack_public_path__ + "static/media/arrow-right-gray-solid.f3e27bfd.png";